import { TemplateData } from './htmlTemplates';

export const minimalistCleanTemplate = {
  id: 'minimalist-clean',
  name: '极简清新',
  description: '简约设计，适合生活方式和文艺内容',
  category: 'lifestyle',
  generate: (data: TemplateData) => `
    <!DOCTYPE html>
    <html lang="zh-CN">
    <head>
      <meta charset="UTF-8">
      <meta name="viewport" content="width=device-width, initial-scale=1.0">
      <title>Cover</title>
      <style>
        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
        }

        .cover {
          width: 400px;
          height: 600px;
          background: #fafafa;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          padding: 60px 40px;
          font-family: 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', sans-serif;
          position: relative;
          overflow: hidden;
        }

        .brand-simple {
          position: absolute;
          top: 40px;
          right: 40px;
          font-size: 16px;
          color: #999999;
          font-weight: 300;
        }

        .title {
          font-size: 36px;
          font-weight: 300;
          color: #2c2c2c;
          text-align: center;
          line-height: 1.3;
          margin-bottom: 40px;
          letter-spacing: 2px;
        }

        .title-bold {
          font-weight: 700;
          color: ${data.theme.primaryColor};
          position: relative;
        }

        .title-bold::after {
          content: '';
          position: absolute;
          bottom: -8px;
          left: 0;
          right: 0;
          height: 2px;
          background: ${data.theme.primaryColor};
          opacity: 0.3;
        }

        .subtitle {
          font-size: 14px;
          color: #666666;
          text-align: center;
          line-height: 1.8;
          font-weight: 300;
          max-width: 250px;
          letter-spacing: 1px;
        }

        .clean-highlight {
          background: ${data.theme.accentColor}15;
          color: ${data.theme.primaryColor};
          padding: 1px 4px;
          border-radius: 2px;
          font-weight: 400;
          margin: 0 1px;
        }

        .geometric-shape {
          position: absolute;
          top: 80px;
          left: 40px;
          width: 60px;
          height: 60px;
          border: 1px solid ${data.theme.primaryColor}30;
          transform: rotate(45deg);
        }

        .geometric-shape::before {
          content: '';
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 20px;
          height: 20px;
          background: ${data.theme.accentColor};
          border-radius: 50%;
        }

        .bottom-text {
          position: absolute;
          bottom: 60px;
          left: 50%;
          transform: translateX(-50%);
          font-size: 10px;
          color: #cccccc;
          letter-spacing: 3px;
          text-transform: uppercase;
        }

        .side-line {
          position: absolute;
          left: 20px;
          top: 50%;
          transform: translateY(-50%);
          width: 1px;
          height: 200px;
          background: linear-gradient(to bottom, transparent, ${data.theme.primaryColor}50, transparent);
        }
      </style>
    </head>
    <body>
      <div class="cover">
        <div class="brand-simple">${data.theme.logo}</div>
        <div class="geometric-shape"></div>
        <div class="side-line"></div>
        <h1 class="title">
          ${data.title.split(' ').map((word, i) => 
            i === 0 ? `<span class="title-bold">${word}</span>` : word
          ).join(' ')}
        </h1>
        <p class="subtitle">${data.subtitle.replace(/([^\s]{3,5})/g, '<span class="clean-highlight">$1</span>')}</p>
        <div class="bottom-text">LIFESTYLE</div>
      </div>
    </body>
    </html>
  `
};
